<template>
<d2-container>
    <h2>车辆登记</h2> 

    <el-form ref="elForm"  size="medium" label-width="100px">
      <el-row>
        <el-form-item label="车牌号" prop="dd">
          <el-input v-model="listQuery.devNo" placeholder="车牌号搜索" clearable :style="{width: '763px'}"></el-input>
        </el-form-item>
      </el-row>
      <el-form-item size="large">
        <el-button size="small" class="filter-item" type="primary" icon="search" @click="handleFilter">查询</el-button>
        <el-button @click="resetForm">重置</el-button>
      </el-form-item>
    </el-form>

    <el-button size="small" class="filter-item" style="margin-left: 10px;" @click="handleCreate" type="primary" icon="edit">添加</el-button>

    <el-table :key='tableKey' :data="list" v-loading.body="listLoading" size="small" stripe highlight-current-row style="width: 100%">

        <el-table-column align="center" label="id" width="65">
            <template slot-scope="scope">
                <span>{{scope.row.id}}</span>
            </template>
        </el-table-column>
        <el-table-column width="100px" align="center" label="品牌">
            <template slot-scope="scope">
                <span>{{scope.row.brand}}</span>
            </template>
        </el-table-column>
        <el-table-column width="120px" align="center" label="车牌号">
            <template slot-scope="scope">
                <span>{{scope.row.devNo}}</span>
            </template>
        </el-table-column>

        <el-table-column width="120px" align="center" label="车牌类型">
            <template slot-scope="scope">
                <span>{{scope.row.devType}}</span>
            </template>
        </el-table-column>
        <el-table-column width="200px" align="center" label="匀选车辆隶属关系">
            <template slot-scope="scope">
                <span>{{scope.row.useType==1?'租用':'自有'}}</span>
            </template>
        </el-table-column>
        <el-table-column width="200px" align="center" label="二维码">
            <template slot-scope="scope">
                <a href="javascript:void(0)" @click="qrcodeImage(scope.row)" style="color:red;">点击查看</a>
            </template>
        </el-table-column>
        <el-table-column  :fit="true" align="center" label="备注">
            <template slot-scope="scope">
                <span>{{scope.row.remark}}</span>
            </template>
        </el-table-column>

        <el-table-column fixed="right" align="center" label="操作" width="150"> <template slot-scope="scope">
                <el-button size="small" type="success" @click="handleUpdate(scope.row)">编辑
                </el-button>
                <el-button size="small" type="danger" @click="handleDelete(scope.row)">删除
                </el-button>
            </template> </el-table-column>
    </el-table>
    <template slot="footer">
        <div v-show="!listLoading" class="pagination-container">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page.sync="listQuery.page" :page-sizes="[10,20,30, 50]" :page-size="listQuery.limit" layout="total, sizes, prev, pager, next, jumper" :total="total"> </el-pagination>
        </div>
    </template>

    <el-dialog :title="textMap[dialogStatus]" :visible.sync="dialogFormVisible">
        <el-form :model="form" :rules="rules" ref="form" label-width="140px">
            <el-form-item label="品牌" prop="brand">
                <el-input v-model="form.brand" placeholder="请输入品牌"></el-input>
            </el-form-item>
            <el-form-item label="车牌号" prop="devNo">
                <el-input v-model="form.devNo" placeholder="请输入车牌号"></el-input>
            </el-form-item>
            <el-form-item label="车牌类型" prop="devType">
                <el-input v-model="form.devType" placeholder="请输入车牌类型"></el-input>
            </el-form-item>
            <el-form-item label="车牌类型">
                <el-select v-model="form.modelId" placeholder="请选择" @change="changeModel">
                    <el-option
                    v-for="item in carModelList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="匀选车辆隶属关系" prop="useType">
                <!--      <el-input v-model="form.useType" placeholder="请输入类型（0自有，1租用）"></el-input>-->
                <el-radio v-model="form.useType" :label="0">自有</el-radio>
                <el-radio v-model="form.useType" :label="1">租用</el-radio>
            </el-form-item>
            <el-form-item label="备注" prop="remark">
                <el-input v-model="form.remark" placeholder="请输入备注"></el-input>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="cancel('form')" size="small">取 消</el-button>
            <el-button v-if="dialogStatus=='create'" size="small" type="primary" @click="create('form')">确 定</el-button>
            <el-button v-else type="primary" size="small" @click="update('form')">确 定</el-button>
        </div>
    </el-dialog>

    <el-dialog :visible.sync="dialogImageVisible" width="30%">
        <img :src="imageUrl" alt="请右键下载" style="width:100%;">
    </el-dialog>
</d2-container>
</template>

<script>
import {
    page,
    addObj,
    getObj,
    delObj,
    putObj,
    qrcode
} from '@/api/admin/sysCarMeta/index';
import {
    carModelList
} from '@/api/admin/sysCarModel/index';

import {
    mapGetters
} from 'vuex';
export default {
    name: 'sysCarMeta',
    data() {
        return {
            imageUrl: "",
            dialogImageVisible: false,
            carModelList:[],
            form: {
                brand: undefined,
                devNo: undefined,
                devType: undefined,
                useType: undefined,
                remark: undefined,
                entId: undefined
            },
            rules: {
                brand: [{
                    required: true,
                    message: '请输入品牌',
                    trigger: 'blur'
                }],
                devNo: [{
                    required: true,
                    message: '请输入车牌号',
                    trigger: 'blur'
                }],
                useType: [{
                    required: true,
                    message: '请输入类型',
                    trigger: 'blur'
                }]
            },
            list: null,
            total: null,
            listLoading: true,
            listQuery: {
                page: 1,
                limit: 20,
                devNo: ""
            },
            dialogFormVisible: false,
            dialogStatus: '',
            textMap: {
                update: '编辑',
                create: '创建'
            },
            tableKey: 0
        }
    },
    created() {
        this.getList();
        this.modelList();
    },
    computed: {
        ...mapGetters([
            'elements'
        ])
    },
    methods: {
        qrcodeImage(row) {
            qrcode(row.encryptId).then(res => {
                this.imageUrl = "data:image/png;base64," + res;
                this.dialogImageVisible = true;
            })
        },
        changeModel(modelId){
            let model =  this.carModelList.filter(x=>x.value==modelId);
            if(model && (model = model[0])){
                this.form.devType = model.label;
            }
        },
        modelList(){ 
            carModelList().then(res=>{
                this.carModelList = res;
            });
        },
        getList() {
            this.listLoading = true;
            page(this.listQuery).then(response => {
                this.list = response.rows;
                this.total = response.total;
                this.listLoading = false;
            })
        },
        handleFilter() {
            this.getList();
        },
        handleSizeChange(val) {
            this.listQuery.limit = val;
            this.getList();
        },
        handleCurrentChange(val) {
            this.listQuery.page = val;
            this.getList();
        },
        handleCreate() {
            this.resetTemp();
            this.dialogStatus = 'create';
            this.dialogFormVisible = true;
        },
        handleUpdate(row) {
            getObj(row.id)
                .then(response => {
                    this.form = response;
                    this.dialogFormVisible = true;
                    this.dialogStatus = 'update';
                });
        },
        handleDelete(row) {
            this.$confirm('此操作将永久删除, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                })
                .then(() => {
                    delObj(row.id)
                        .then(() => {
                            this.$notify({
                                title: '成功',
                                message: '删除成功',
                                type: 'success',
                                duration: 2000
                            });
                            const index = this.list.indexOf(row);
                            this.list.splice(index, 1);
                        });
                });
        },
        create(formName) {
            const set = this.$refs;
            set[formName].validate(valid => {
                if (valid) {
                    addObj(this.form)
                        .then(() => {
                            this.dialogFormVisible = false;
                            this.getList();
                            this.$notify({
                                title: '成功',
                                message: '创建成功',
                                type: 'success',
                                duration: 2000
                            });
                        })
                } else {
                    return false;
                }
            });
        },
        cancel(formName) {
            this.dialogFormVisible = false;
            const set = this.$refs;
            set[formName].resetFields();
        },
        update(formName) {
            const set = this.$refs;
            set[formName].validate(valid => {
                if (valid) {
                    this.dialogFormVisible = false;
                    this.form.password = undefined;
                    putObj(this.form.id, this.form).then(() => {
                        this.dialogFormVisible = false;
                        this.getList();
                        this.$notify({
                            title: '成功',
                            message: '创建成功',
                            type: 'success',
                            duration: 2000
                        });
                    });
                } else {
                    return false;
                }
            });
        },
        resetTemp(){
            this.form={
                brand: undefined,
                devNo: undefined,
                devType: undefined,
                useType: undefined,
                remark: undefined,
                entId: undefined
            }
        },
        resetForm() {
            this.listQuery = { 
                page: 1,
                limit: 20,
                devNo: ""
            };
        }
    }
}
</script>
